export default "__VITE_ASSET__B8b2KZPH__"